<template>
  <div class="ExpertsPastStrategyOptions">
    <MobileNav :page_title="nav_title"></MobileNav>

    <LivePriceTickerVue></LivePriceTickerVue>

    <div class="ExpertsPastStrategyOptionsContainer">
      <div class="desktopFilterSection">
        <!-- sent filter_list as props to desktop filter component to display filters by page type -->
        <FilterForDesktopViewDerivatives :filter_title="filter_title" :filter_list="filter_list" user_type="expert"></FilterForDesktopViewDerivatives>
      </div>

      <div v-if="isPremiumPlan" class="TopPotentialStrategies">
        <TopPotentialsStrategies @getRecoById="getRecommendationById" :strategies="topPotentialStrategyList" :expertView="'Options'" :isRecoListLoading="isRecoListLoading"></TopPotentialsStrategies>
      </div>

      <div class="search-container">
        <div v-if="isPremiumPlan" class="search-stock-section">
          <search-stock class="search-stock-component"></search-stock>
          <div class="flex-center mobile-filter-section" v-if="isPremiumPlan && !isDesktop">
            <img class="mobile-filter cursor-pointer" src="../assets//images/filter.svg" alt="" @click="openFilterDialog()" />
            <div class="filter-count" v-if="filterCount">{{ filterCount }}</div>
          </div>
        </div>
      </div>

      <div class="recoListSection">
        <div v-if="!is_reco_list_loading && !other_expert_past_reco_list.length">
          <NoDataFound></NoDataFound>
        </div>

        <div class="stock-data-section">
          <OptionStrategyCard :recommendationsList="other_expert_past_reco_list" @getByExpertName="getRecoByExpertName" @openStockWidget="openStockWidget"></OptionStrategyCard>
        </div>

        <!-- btn to load more recos -->
        <div v-if="!currentUrl.includes('almondz.stockants.com') && !currentUrl.includes('almondztrade.stockants.com')">
          <div class="show-more-tab" v-if="this.number_of_pages > this.page_no && !is_reco_list_loading" @click="loadMoreRecommendations()">Load more</div>
        </div>
        <div v-if="(currentUrl.includes('almondz.stockants.com') || currentUrl.includes('almondztrade.stockants.com')) && isPremiumPlan">
          <div class="show-more-tab" v-if="this.number_of_pages > this.page_no && !is_reco_list_loading" @click="loadMoreRecommendations()">Load more</div>
        </div>

        <div :class="{ 'infinite-loader-top-position': page_no == 1 }" v-if="is_reco_list_loading">
          <div class="text-center">
            <img src="../assets/images/company/loader.svg" style="height: 80px; width: 80px" />
            <p>Please wait, page is loading . . .</p>
          </div>
        </div>
      </div>
    </div>

    <!-- video dialog -->
    <div id="video-section">
      <el-dialog :visible.sync="videoDialog" :before-close="videoDialogClose" center>
        <iframe id="videoId" width="100%" height="600px" :src="activeVideo" title="YouTube video player" frameborder="0" allowscriptaccess="always" allow="accelerometer; autoplay:true; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </el-dialog>
    </div>

    <!-- filters for mobile view -->
    <!-- isDesktop return true if window size is 1197px other wise false -->
    <StockFilter v-if="!isDesktop" :filter_title="filter_title" :filter_list="filter_list" user_type="expert" class="nav-filter-icon"></StockFilter>

    <el-dialog custom-class="stock-widget-dialog" :visible.sync="stock_widget_visible" :before-close="handleClose">
      <div>
        <iframe :src="'https://stocks.tickertape.in/' + stock_code + '?broker=stockants'" width="100%" height="400px"></iframe>
      </div>
    </el-dialog>

    <div v-if="userProfile != null">
      <ProcessKycComponent :planDetails="planSubscriptionStatusDetails"></ProcessKycComponent>
    </div>
  </div>
</template>

<script>
import ProcessKycComponent from '@/components/NewKycFlow.vue';
import { serverAddr } from '../networkConfig';
import MobileNav from '@/components/MobileNav.vue';
import RecoActionButtons from '@/components/RecoActionButtons.vue';
import MobileFilterDialog from '@/components/MobileFilterDialogDerivatives.vue';
import FilterForDesktopViewDerivatives from '@/components/FilterForDesktopViewDerivatives.vue';
import { HelperNetworkCallBack } from '../mixins/Helper';
import { screenSize } from '../mixins/ScreenSize.js';
import { filterCallBack } from '../mixins/filter';
import { EventBus } from '../eventBus';
import NoDataFound from '@/components/NoDataFound.vue';
import moment from 'moment';
import OptionStrategyCard from '@/components/OptionStrategyCard.vue';
import { derivativesApiCall } from '../mixins/DerivativesApi';
import SearchStock from '@/components/SearchStockDerivatives.vue';
import { updateProfileNetworkCallBack } from '../mixins/UpdateProfile.NetworkCallBack';
import TopPotentialsStrategies from '../components/TopPotentialsRecos.vue';
import LivePriceTickerVue from '../components/LivePriceTicker.vue';
export default {
  name: 'ExpertsPastStrategyOptions',

  mixins: [HelperNetworkCallBack, filterCallBack, screenSize, derivativesApiCall, updateProfileNetworkCallBack],

  components: {
    MobileNav,
    'search-stock': SearchStock,
    NoDataFound,
    RecoActionButtons,
    FilterForDesktopViewDerivatives,
    OptionStrategyCard,
    StockFilter: MobileFilterDialog,
    ProcessKycComponent,
    TopPotentialsStrategies,
    LivePriceTickerVue,
  },

  data() {
    return {
      moment: moment,
      planSubscriptionStatusDetails: null,
      nav_title: 'Experts Recommendations',
      filter_title: 'Experts recommendations',
      filter_obj: {
        company_id_list: [],
        expert_id_list: [],
        filters: [],
      },
      filter_list: [
        {
          title: 'Market Experts',
          experts: ['Financial Advisor', 'Analyst'],
        },
        {
          title: 'Strategy status',
          filter: [
            'Live',
            'Updated',
            // "Closed",
            'Yet to live',
            'Complete',
            'Incomplete',
            'Stop loss triggered',
            'Exit',
          ],
        },
        {
          title: 'Strategy Type',
          filter: ['Bearish', 'Bullish'],
        },
        // {
        //   title: "Option Type",
        //   filter: ["Indices", "Stocks"],
        // },
      ],
      is_reco_list_loading: true, //loader placeholder
      other_expert_past_reco_list: [],
      strategy_id: '',
      sector: '',
      is_scroll_disabled: true,
      page_no: 1,
      number_of_pages: null,
      stock_code: '',
      stock_widget_visible: false,
      campaignId: null,
      notificationData: [],
      plan_sub_noitificaion_dialog_visibility: false,
      activeVideo: 'https://youtube-nocookie.com/embed/QkUAhPDy81I',
      videoDialog: false,
      strikeSymbol: '',
      searchIndiceExpiry: '',
      indiceName: '',
      currentEnvironment: {},
      websiteUserType: localStorage.getItem('websiteUserType') ? JSON.parse(localStorage.getItem('websiteUserType')) : {},
      userProfile: {},
      is_profile_save_loading: false,
      isApiLoading: false,
      selected_reco_id: [],
      filterCount: 0,
      currentUrl: localStorage.getItem('currentUrl') ? localStorage.getItem('currentUrl') : window.location.href,
      isRecoListLoading: false,
      topPotentialStrategyList: [],
    };
  },

  watch: {
    getPlanSubscriptionStatus(newValue, oldValue) {
      this.planSubscriptionStatusDetails = newValue.message;

      if (this.planSubscriptionStatusDetails && this.planSubscriptionStatusDetails.extra_info.transaction_status == 'SUCCESS') {
        if (this.planSubscriptionStatusDetails.data.plan == 'Publisher') {
          localStorage.setItem('publisher_plan_details', JSON.stringify(this.planSubscriptionStatusDetails.data));
        } else {
          localStorage.setItem('plan_details', JSON.stringify(this.planSubscriptionStatusDetails.data));
        }

        this.$store.commit('commitKycDialog', true);
      }
    },

    filter_obj: {
      handler(newValue) {
        this.appliedFilters = [];

        // Check if the filter object is empty
        const isEmpty = Object.values(newValue).every((value) => {
          if (Array.isArray(value)) {
            return value.length === 0; // Empty array
          } else if (typeof value === 'object' && value !== null) {
            return Object.keys(value).length === 0; // Empty object
          }
          return !value; // Falsy value
        });

        if (isEmpty) {
          this.appliedFilters = [];
          this.filterCount = 0;
          return; // Exit early since there’s nothing to process
        }

        // Process each key in the filter object
        for (const key in newValue) {
          const value = newValue[key];

          if (Array.isArray(value) && value.length > 0) {
            value.forEach((item) => {
              this.toggleFilter(item); // Add or remove the filter
            });
          } else if (typeof value === 'string' && value.trim() !== '') {
            this.toggleFilter(value);
          } else if (typeof value === 'object' && Object.keys(value).length > 0) {
            this.toggleFilter(value.key); // Use `value.key` for object values
          }
        }
      },
      deep: true, // Ensure nested changes are detected
      immediate: true, // Run on initialization
    },
  },

  created() {
    if (!localStorage.getItem('currentEnvironment')) {
      this.selectUserType();
    }
    this.userProfile = JSON.parse(localStorage.getItem('profile'));

    if (localStorage.getItem('currentEnvironment')) {
      this.currentEnvironment = JSON.parse(localStorage.getItem('currentEnvironment'));
      // if (!this.currentEnvironment.byPassLogin) {
      this.addWatchlistFilter();
      // }
    }
  },

  mounted() {
    // Call getUserProfile initially
    this.getUserProfile();

    //event emitted when searched stock input field is cleared
    EventBus.$on('clearedSearchedStock', () => {
      this.strategy_id = null;
      this.page_no = 1;
    });

    EventBus.$on('clearedSelectedFilter', (filter_obj) => {
      this.strategy_id = null;
      this.page_no = 1;
      this.other_expert_past_reco_list = [];
      this.selected_reco_id = [];
      this.scrollToTop();
      this.filter_obj = filter_obj;
      this.indiceName = '';
      this.searchIndiceExpiry = '';
      this.strikeSymbol = '';

      // if user id, stock id or sector in url's query params then on cleared filter pushed them on relative filterobj
      // to get data accordingly
      if (this.$route.query.stock_id) {
        this.strategy_id = this.$route.query.stock_id;
      } else if (this.$route.query.user_id) {
        //if response type is company then sent user id in company id list other wise in expert id list
        if (this.$route.query.user == 'company') {
          this.filter_obj.company_id_list.push(this.$route.query.user_id);
        } else {
          this.filter_obj.expert_id_list.push(this.$route.query.user_id);
        }
      } else if (this.$route.query.sector) {
        this.sector = this.$route.query.sector;
      }

      this.getOtherExpertsPastRecoList(this.filter_obj);
    });

    EventBus.$on('emitSelectedFilters', (filter_obj) => {
      this.page_no = 1;
      this.other_expert_past_reco_list = [];
      this.selected_reco_id = [];
      this.strategy_id = null;
      this.scrollToTop();
      this.filter_obj = filter_obj;

      //if params in route then pushed stock id in strategy_id
      if (this.$route.query.stock_id) {
        this.strategy_id = this.$route.query.stock_id;
      } else if (this.$route.query.user_id) {
        //if response type is company then sent user id in company id list other wise in expert id list
        this.filter_obj.expert_id_list.push(this.$route.query.user_id);
      } else if (this.$route.query.sector) {
        this.sector = this.$route.query.sector;
      } else if (this.$route.query.filter) {
        this.filter_obj.filters.push(this.$route.query.filter);
      }

      this.getOtherExpertsPastRecoList(this.filter_obj);

      this.removeQueryParam();
    });

    //event emmited when stock is selected
    EventBus.$on('selectedStock', (stock) => {
      this.page_no = 1;
      this.strategy_id = '';
      this.indiceName = stock.title;
      this.searchIndiceExpiry = stock.expiry;
      this.strikeSymbol = '';

      this.other_expert_past_reco_list = [];
      this.selected_reco_id = [];
      this.strategy_id = stock.id;

      this.scrollToTop(); //scroll to top of list
      this.getOtherExpertsPastRecoList(this.filter_obj);
    });

    //event emmited when strike price is selected
    EventBus.$on('selectedStrike', (strike) => {
      this.page_no = 1;
      this.strategy_id = '';
      this.other_expert_past_reco_list = [];
      this.selected_reco_id = [];
      this.strikeSymbol = strike.symbol;

      this.scrollToTop(); //scroll to top of list

      this.getOtherExpertsPastRecoList(this.filter_obj);
    });

    EventBus.$on('emitWatchListFilters', (filter_obj) => {
      if (this.isApiLoading) return;

      if (filter_obj) {
        this.page_no = 1;
        this.other_expert_past_reco_list = [];
        this.selected_reco_id = [];
        this.scrollToTop();
        if (this.filter_obj.filters.includes('followed strategies')) {
          let index = this.filter_obj.filters.indexOf('followed strategies');
          this.filter_obj.filters.splice(index, 1);
        } else {
          this.filter_obj.filters.push('followed strategies');
        }

        this.getOtherExpertsPastRecoList(this.filter_obj);
      }
    });

    EventBus.$on('toggleButtonLoading', (isLoading) => {
      this.isApiLoading = isLoading;
    });

    this.$root.$emit('getCampaignData');

    // run this after each 3 mins to refresh contents
    if (this.websiteUserType && this.websiteUserType.userType == 'broker') {
      setInterval(() => {
        window.location.reload(true);
      }, 5 * 60 * 1000);
    }
  },
  beforeRouteEnter(to, from, next) {
    var userPlan = JSON.parse(localStorage.getItem('plan_details'));

    if (!userPlan || (userPlan && userPlan.plan == 'Lite')) {
      next('/expert-view-lite');
    } else {
      next();
    }
  },
  methods: {
    getTopStrategies() {
      this.isRecoListLoading = true; // Start loader
      this.topPotentialStrategyList = [];

      serverAddr
        .get('/options/top_potentai_startegies')
        .then((response) => {
          if (response.data.status && response.data.data.length > 0) {
            this.topPotentialStrategyList = response.data.data.map((item) => {
              const strategy = item.strategy || {};
              const userDetails = strategy.user_details || {};
              const direction = strategy.direction ? strategy.direction : '';

              return {
                riskCategory: strategy.risk_tag || 'N/A',
                title: strategy.title || 'N/A',
                createdDate: strategy.created_date || 'N/A',
                avgRemainingPotential: strategy.avg_remaining_potential_in_perc || 0,
                direction: direction,
                riskTag: strategy.risk_tag || 'N/A',
                userProfilePic: userDetails.pic || '',
                strategy_id: strategy.id,
                userName: userDetails.full_name,
                sebiNumber: userDetails.sebi_regi_number,
              };
            });
          } else {
            this.topPotentialStrategyList = [];
          }
        })
        .catch((error) => {
          console.log('Error fetching strategies:', error);
          this.topPotentialStrategyList = [];
        })
        .finally(() => {
          this.isRecoListLoading = false; // Stop loader
        });
    },

    toggleFilter(filter) {
      var index = this.appliedFilters.indexOf(filter);
      if (index > -1) {
        this.appliedFilters.splice(index, 1);
      } else {
        this.appliedFilters.push(filter);
      }
      this.filterCount = this.appliedFilters.length;
    },
    openFilterDialog() {
      EventBus.$emit('openFilterDialog');
    },
    getRecommendationById(id_list) {
      this.strategy_id = ''; //cleared previously selected stocks
      this.selected_reco_id = []; //cleared previously selected reco
      this.other_expert_past_reco_list = []; //cleared previous results
      this.page_no = 1;

      this.selected_reco_id = id_list;

      this.scrollToTop(); //scroll to top of list
      this.getOtherExpertsPastRecoList(this.filter_obj);
    },
    getUserProfile() {
      this.is_profile_save_loading = true;

      serverAddr
        .get('/auth/v1/profile')
        .then(this.getProfileCallBack)
        .catch(function (error) {
          console.log(error);
        });

      // Store the current calling time in localStorage
      const currentTime = moment().format('YYYY-MM-DD HH:mm:ss');
      localStorage.setItem('lastProfileCall', currentTime);
    },

    removeQueryParam() {
      // Access the current query parameters
      let queryParams = { ...this.$route.query };
      // Remove a specific query parameter (e.g., 'example')
      delete queryParams.stock_id;
      delete queryParams.user_id;
      delete queryParams.user;
      delete queryParams.public;
      delete queryParams.filter;

      // Update the URL without the query parameter
      this.$router.push({ query: queryParams });
    },
    addWatchlistFilter() {
      let websiteUserType = localStorage.getItem('websiteUserType') ? JSON.parse(localStorage.getItem('websiteUserType')) : {};

      if (websiteUserType && websiteUserType.userType == 'broker') {
        this.filter_list.push({
          title: 'Watchlist',
          filter: ['followed strategies', 'traded strategies'],
        });
      } else {
        this.filter_list.push({
          title: 'Watchlist',
          filter: ['followed strategies'],
        });
      }
    },
    videoDialogClose() {
      this.videoDialog = false;
      let video = document.getElementById('videoId');
      let url = video.getAttribute('src');
      video.setAttribute('src', '');
      video.setAttribute('src', url);
    },
    openTradeWidget(stock_code, reco_id) {
      if (KiteConnect) {
        KiteConnect.ready(async function () {
          // Initialize a new Kite instance.
          // You can initialize multiple instances if you need.
          let kite = await new KiteConnect('s8r229rs5vrd6yzn');

          kite.add({
            exchange: 'NSE',
            tradingsymbol: stock_code,
            quantity: 1,
            order_type: 'LIMIT',
            // "transaction_type": "SELL",
            // "price": 105
          });

          // Register an (optional) callback.
          kite.finished(function (status, request_token) {});

          let id = '#default-button' + reco_id;

          // Render the in-built button inside a given target
          kite.renderButton(id);
        });
      }
    },

    openStockWidget(stock_code) {
      this.stock_code = stock_code;
      this.stock_widget_visible = true;
    },

    // close stock widget dialog
    handleClose() {
      this.stock_widget_visible = false;
    },

    getRecoByExpertName(expert) {
      this.filter_obj.expert_id_list = []; //cleared previously selected experts
      this.filter_obj.company_id_list = []; //cleared previously selected company
      this.strategy_id = ''; //cleared previously selected stocks

      if (expert.filtered_by == 'company') {
        this.filter_obj.company_id_list.push(expert.user.company.id); //pushed experts profile id
      } else {
        this.filter_obj.expert_id_list.push(expert.user.user_profile_id); //pushed experts profile id
      }

      this.page_no = 1;
      this.other_expert_past_reco_list = []; //cleared previous results
      this.selected_reco_id = [];
      this.scrollToTop(); //scroll to top of list
      this.getOtherExpertsPastRecoList(this.filter_obj);
    },

    scrollToTop() {
      var elmnt = document.getElementsByClassName('recoListSection');
      scrollTo(elmnt, 0, 100);
    },

    loadMoreRecommendations() {
      this.page_no = this.page_no + 1;
      if ((!Object.keys(this.subscribedPlanDetails).length || this.subscribedPlanDetails.plan == 'Lite') && this.page_no > 1) {
        this.page_no = 1; //reset to page no 1
        this.$store.commit('commitSubscribPlanDialogVisibility', true);
        return;
      }
      // this.number_of_pages = null;     //to disable load more tab
      this.getOtherExpertsPastRecoList(this.filter_obj);
    },

    //initially called api to get all experts who uploaded reco
    async getOtherExpertsPastRecoList(filter_obj) {
      this.is_reco_list_loading = true;
      // await this.getExpertData(filter_obj);
      await this.getExperStrategytData(filter_obj);
    },

    loadMoreStocks() {
      window.onscroll = () => {
        //checked is window scrolled to bottom
        if (window.innerHeight + window.scrollY >= document.body.scrollHeight && this.is_scroll_disabled && this.number_of_pages > this.page_no) {
          // you're at the bottom of the page

          if ((!Object.keys(this.subscribedPlanDetails).length || this.subscribedPlanDetails.plan == 'Lite') && localStorage.getItem('access_to_expert_dashboard')) {
            if (localStorage.getItem('access_to_expert_dashboard') != this.$route.query.user_id) {
              this.stock_rank_board_page_no = 1; //reset to page no 1
              this.$store.commit('commitSubscribPlanDialogVisibility', true);
              return;
            }
          } else if (!Object.keys(this.subscribedPlanDetails).length || this.subscribedPlanDetails.plan == 'Lite') {
            this.stock_rank_board_page_no = 1; //reset to page no 1
            this.$store.commit('commitSubscribPlanDialogVisibility', true);
            return;
          }

          this.page_no = this.page_no + 1;
          this.getOtherExpertsPastRecoList(this.filter_obj);
          this.is_scroll_disabled = false; //disabled scroll to avoid many time function call
        }
      };
    },
  },

  computed: {
    // userProfile() {
    //   return JSON.parse(localStorage.getItem("profile"));
    // },

    getPlanSubscriptionStatus() {
      return this.$store.state.planStatus;
    },

    //returns subscribed plan details from local storage
    subscribedPlanDetails() {
      return JSON.parse(localStorage.getItem('plan_details'));
    },
    isPremiumPlan() {
      const planDetails = this.subscribedPlanDetails;

      if (this.userProfile && planDetails && planDetails.plan === 'Premium') {
        this.getTopStrategies();
      }
      return this.userProfile && planDetails && planDetails.plan === 'Premium';
    },
  },

  beforeDestroy() {
    EventBus.$off();
    // window.removeEventListener('scroll', this.loadMoreStocks());
    // this.is_scroll_disabled = false;
  },
};
</script>

<style lang="scss" scoped>
@import '../css/variable.scss';
@import '../css/common.scss';

.ExpertsPastStrategyOptions {
  // min-height: 100vh;
  background-color: $page-background-color;
  padding: 105px 0 0 0;
}

.ExpertsPastStrategyOptions .search-container,
.TopPotentialStrategies {
  /* box-shadow: 10px 0 20px 0px lightgrey; */
  box-sizing: border-box;
  // position: fixed;
  width: calc(100% - 285px);
  margin-left: 285px;
  padding: 0px 10px 10px 10px;
  z-index: 2;
}

.ExpertsPastStrategyOptions .search-stock-section {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  box-sizing: border-box;
  background-color: $page-background-color;
  padding: 10px 0px 0px 10px;
  width: 100%;

  .filter-count {
    position: relative;
    bottom: 13px;
    right: 6px;
    padding: 2px 6px;
    background-color: #2488ff;
    font-size: 12px;
    font-weight: 600;
    border-radius: 50%;
    color: #fff;
  }

  .selected-filters {
    // width: 250px;
    display: flex;
    align-items: center;

    margin-top: 10px;

    .tabs-outer {
      display: flex;
      // width: 200px;
      flex-wrap: wrap;
    }

    .tabs {
      font-size: 0.6rem;
      font-weight: 500;
      background-color: #dde1ed;
      color: #606060;
      border-radius: 50px;
      padding: 3px 10px;
      margin: 2px 5px;
    }
  }
}

.ExpertsPastStrategyOptions .recoListSection {
  box-sizing: border-box;
  width: calc(100% - 285px);
  margin-left: 285px;
  padding: 0 10px;
  min-height: calc(100vh - 70px);
  padding-bottom: 60px !important;
}

.ExpertsPastStrategyOptions .footer-section {
  width: calc(100% - 285px);
  margin-left: 285px;
}

.ExpertsPastStrategyOptions .more-info-section {
  text-align: center;
  margin: 10px 0;
}

.ExpertsPastStrategyOptions .btn-gradient {
  background-image: linear-gradient(to left, #dc6250, #eb5151);
  margin: 10px 0 30px;
  width: 220px;
  outline: none;
  border-radius: 25px;
  height: 40px;
  color: #fff;
  font-size: 14px;
  border: none;
  cursor: pointer;
}

.ExpertsPastStrategyOptions .btn-gradient:hover {
  transition: 0.4s ease;
  box-shadow: 0px 0px 10px -1px #dc6250;
}

.ExpertsPastStrategyOptions .plan-notification-dialog {
  .el-dialog {
    width: 40%;
    border-radius: 10px;
  }
}

.ExpertsPastStrategyOptions .stock-data-section {
  padding: 0px 0px 0;
}

//media queries
@media screen and (max-width: 1283px) {
  .ExpertsPastStrategyOptions {
    padding: 105px 0 0 0;
  }

  .ExpertsPastStrategyOptions .recoListSection {
    width: 100%;
    margin-left: 0;
  }

  .ExpertsPastStrategyOptions .footer-section {
    width: 100%;
    margin-left: 0;
  }

  .ExpertsPastStrategyOptions .search-container,
  .TopPotentialStrategies {
    width: 100%;
    margin-left: 0;
    padding: 0;
  }

  .ExpertsPastStrategyOptions .search-stock-section {
    padding: 20px 10px 10px 10px;
  }

  .ExpertsPastStrategyOptions .stock-data-section {
    padding: 10px 0px 0;
  }

  .ExpertsPastStrategyOptions .action-btn-component {
    display: flex;
    justify-content: center;
    margin: 10px 0;
  }

  .ExpertsPastStrategyOptions .desktopFilterSection {
    display: none;
  }
}

@media screen and (max-width: 850px) {
  .ExpertsPastStrategyOptions .plan-notification-dialog {
    .el-dialog {
      width: 94%;
    }
  }

  .ExpertsPastStrategyOptions {
    .custom-seach-input {
      width: 240px;
    }
  }

  // .ExpertsPastStrategyOptions .stock-data-section {
  //   padding: 120px 0px 0;
  // }
}

@media screen and (max-width: 600px) {
  .ExpertsPastStrategyOptions .recoListSection {
    padding: 0;
  }

  .ExpertsPastStrategyOptions .mobile-filter-section {
    width: 100%;
    justify-content: end;
    margin-top: 10px;
  }
}
</style>
